import React, { useState} from 'react'
import { IonPage, IonContent } from '@ionic/react';
import Gestion from 'src/services/gestionMarcacion';
import { Paper, Typography, Button, ButtonGroup, makeStyles } from '@material-ui/core'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import SaveIcon from '@material-ui/icons/Save';
import { closeOutline } from "ionicons/icons";
import { useHistory } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import HeaderGenerico from '../HeaderGenerico';
import { Stack } from '@mui/material';
import DoneAllOutlinedIcon from '@material-ui/icons/DoneAllOutlined';


// Marca de gestión local para Gestión de Errores.
// Importante: no implica que el HNP ya desaparezca (eso depende de reproceso/procesamiento);
// solo fuerza a mostrar "GESTIONADO" al volver desde esta pantalla.
const STORAGE_KEY_GESTION_MARCACION = 'gestion_errores:gestion_marcacion:ultimo';


const useStyles = makeStyles((theme) => ({
    root:{
      padding: '20px',
      alignContent: 'center',
      textAlign: 'center',
      margin: theme.spacing(2)
    },
    text: {
      color: 'white',
    },
    colorModal: {
      color: 'black',
      margin: theme.spacing(3),
    },
    button: {
      backgroundColor: '#900533',
      width: '96%',
      margin: theme.spacing(1),
    },
    buttonGroup: {
      alignContent: 'space-between',
      width: '100%',
      marginTop: '15px',
    
    },
    timePicker: {
        width: '100%',
        forcedColorAdjust: 'inherit'
    },
    paper: {
        width: '96%',
        margin: '0 auto',
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    centeredText: {
      textAlign: 'center',
      fontSize: '20px',
      color: '#900533',
      marginBottom: theme.spacing(2),
    },
  }
  ));


export const GestionMarcacionSalida = ({info}: { info: string }) => {
    const datos = JSON.parse(info);
    const classes = useStyles();
    const [selectedHoraGMS, setSelectedHoraGMS] = useState<Dayjs | null>(null);
    const [disabledLapiz, setDisabledLapiz] = useState(false);
    const [visible, setVisible] = useState(false);
    const [visibleGS, setVisibleGS] = useState(false);
    const [infoStatus, setInfoStatus] = useState('');
    const [infoStatusGestionSalida, setInfoStatusGestionSalida] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();
      const { 
        nombre, 
        nroLegajo,
        fecha, 
        entrada,
        salida, 
        total, 
        idMarcacion, 
        entrada_id, 
        salida_id, 
        tipoMarcacion,
        tipoHora,
        nombrePServicio,
        psId } = datos.info;

    // Normaliza fechas para evitar mandar "Invalid Date" al backend.
    // Acepta:
    // - YYYY-MM-DD
    // - DD/MM/YYYY
    // - ISO / SQL: YYYY-MM-DDTHH:mm:ss / YYYY-MM-DD HH:mm:ss
    // - HTTP-date: Tue, 13 Jan 2026 00:00:00 GMT
    const toISODate = (value: any): string => {
      const raw = String(value ?? '').trim();
      if (!raw) return '';
      const m = raw.match(/^(\d{4}-\d{2}-\d{2})/);
      if (m) return m[1];
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
        const [dd, mm, yyyy] = raw.split('/');
        return `${yyyy}-${mm}-${dd}`;
      }
      const d = dayjs(raw);
      return d.isValid() ? d.format('YYYY-MM-DD') : '';
    };

    const marcarGestionEnGestionErrores = () => {
      try {
        // Usar la misma normalización que el payload (evita guardar "Invalid Date" o formatos raros).
        const fechaISO = toISODate(fecha);
        const legajoNum = Number(nroLegajo);

        sessionStorage.setItem(
          STORAGE_KEY_GESTION_MARCACION,
          JSON.stringify({
            tipo_error: 'SIN-SALIDA',
            ps_nombre: String(nombrePServicio || '').trim(),
            operario_legajo: Number.isFinite(legajoNum) ? legajoNum : null,
            fecha: fechaISO,
          })
        );
      } catch {
        // No bloquear la UX si el storage no está disponible.
      }
    };

    const handleChangeHoraGMS = (newTime: Dayjs | null) => {
        setSelectedHoraGMS(newTime);
       
      };
      

    const savingHoraSalida = () => { 
        setLoading(true)
        const fechaISO = toISODate(fecha);
        if (!fechaISO) {
          setLoading(false);
          console.error('Fecha inválida para generar marcación (salida):', fecha);
          return;
        }
        const payload = {
          tipoMarcacion: 'SALIDA',
          idMarcacion,
          psId,
          fecha: fechaISO,
          legajo: nroLegajo,
          puntoServicio: nombrePServicio,
          hora: selectedHoraGMS ? selectedHoraGMS.format('HH:mm:ss') : '00:00:00',
        };

         Gestion.guardarSalida(payload)
        .then((response) => {
            if( response.status === 200){
              console.log('Respuesta exitosa (Guardar Hora Salida):', response.data.info);
              setInfoStatus(response.data.info);
              setVisible(true);
              setDisabledLapiz(false);
              // Marcar gestionado para el módulo Gestión de Errores.
              marcarGestionEnGestionErrores();
              setTimeout(() => setVisible(false), 5000);
            }})
          .catch((error) => {
            console.error('Error al guardar hora de salida:', error.response?.data || error.message);
            })
          .finally(() => setLoading(false));
        };

    const gestionarSinSalida = () => {
      setLoading(true);

      const fechaISO = toISODate(fecha);
      if (!fechaISO) {
        setLoading(false);
        console.error('Fecha inválida para generar lápiz (sin-salida):', fecha);
        return;
      }

      const payload = {
        nroLegajo,
        fecha: fechaISO,
        salida: selectedHoraGMS ? selectedHoraGMS.format('HH:mm:ss') : '00:00:00',
        idMarcacion,
        nombrePServicio,
        psId,
      };
        Gestion.gestionarSinSalida(payload)
        .then((response) => {
            if( response.status === 200){
                setDisabledLapiz(true);
                setLoading(false);
                setInfoStatusGestionSalida(response.data.info);
                setVisibleGS(true);
                setSelectedHoraGMS(null);
            // Marcar gestionado para el módulo Gestión de Errores.
            marcarGestionEnGestionErrores();
                setTimeout(() => {
                    setVisibleGS(false);
                    setDisabledLapiz(false);
                    }, 10000);
            }
          })
          .catch((error) => {
            console.error('Error al generar lápiz:', error.response?.data || error.message);
          });
      };
      const botonCerrar = {
        icono: closeOutline,
        action: () => history.goBack(),
      };

  return (
    <IonPage>
    <HeaderGenerico textAlign="center" botonIzq={botonCerrar} titulo="Gestión Marcación Salida" />
      <IonContent id="gestionMarcacion">
        <Paper className={classes.paper}>
          <Typography className={classes.centeredText}>GESTIONAR HORA SALIDA</Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              className={classes.timePicker}
              ampm={false}
              label="HORA SALIDA"
              value={selectedHoraGMS}
              onChange={handleChangeHoraGMS}
            />
          </LocalizationProvider>
          <ButtonGroup orientation="vertical" aria-label="vertical button group" className={classes.buttonGroup}>
            <Button
              variant="contained"
              onClick={savingHoraSalida}
              className={classes.button}
              disabled={!selectedHoraGMS}
            >
              <Typography className={classes.text}>
                <SaveIcon style={{ color: 'white' }} />
                Guardar Salida
              </Typography>
            </Button>
            <Button
              variant="contained"
              onClick={gestionarSinSalida}
              className={classes.button}
              disabled={disabledLapiz}
            >
              <Typography className={classes.text}>Modificar Sin Salida</Typography>
            </Button>
          </ButtonGroup>
        </Paper>
        <div className={classes.root}>
          {visible && (
            <>
              <DoneAllOutlinedIcon style={{ fontSize: '100px', color: '#900533' }} />
              <Typography style={{ fontSize: '20px' }}>{infoStatus}</Typography>
            </>
          )}
          {loading && (
            <div>
              <Skeleton />
              <Skeleton animation={false} />
              <Skeleton animation="wave" />
            </div>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

